import createAPI from '../axios'

// 在校证明 API
const certificate = {
    atSchoolCertificate: {
        export: config => createAPI('/certificate/atSchoolCertificate/export', 'post', config),

        print: config => createAPI('/certificate/atSchoolCertificate/print', 'post', config),

        queryList: config => createAPI('/certificate/atSchoolCertificate/queryList', 'post', config),

        save: config => createAPI('/certificate/atSchoolCertificate/save', 'post', config),

        submit: config => createAPI('/certificate/atSchoolCertificate/submit', 'post', config),

        updateAuditState: config => createAPI('/certificate/atSchoolCertificate/updateAuditState', 'post', config),

        initCombo: config => createAPI('/certificate/atSchoolCertificate/initCombo', 'post', config),

        queryListStu: config => createAPI('/certificate/atSchoolCertificate/queryListStu', 'post', config),

        updatePrintState: config => createAPI('/certificate/atSchoolCertificate/updatePrintState', 'post', config),

        clickCreate: config => createAPI('/certificate/atSchoolCertificate/clickCreate', 'post', config),

        choseTime: config => createAPI('/certificate/atSchoolCertificate/choseTime', 'post', config),

        delTempFile: config => createAPI('/certificate/atSchoolCertificate/delTempFile', 'post', config),

        allowApply: config => createAPI('/certificate/atSchoolCertificate/allowApply', 'post', config),

        queryAuditFlow: config => createAPI('/certificate/atSchoolCertificate/queryAuditFlow', 'post', config),
    },
};

export default certificate;



// WEBPACK FOOTER //
// ./src/api/modules/certificate.js